import { FaTrash } from 'react-icons/fa';

const WorkTable = ({ work , setWork}) => {

    const removeJob = (job) => {
        
        let newWork = work.filter((works) => {
            return works.occupation !== job.occupation ;
        });
        setWork( newWork);
    }
    return ( 
        <>
            <table className="mt-2">
                <thead>
                    <tr>
                        <th>Period</th>
                        <th>Job Title</th>
                        <th>Employer Name</th>
                        <th>Address</th>
                        <th> </th>
                    </tr>
                    </thead>
                    <tbody>            
                        {
                            work && work.map(job => (
                                <tr key={job.employerName}>
                                    <td>{job.fromDate} to {job.toDate}</td>
                                    <td>{job.occupation}</td>    
                                    <td>{job.employerName}</td>    
                                    <td>{job.workAddress}</td>   
                                    <td>
                                        <FaTrash 
                                            color="#af0e19" 
                                            onClick={() => removeJob(job)}
                                        />
                                    </td>   
                                </tr>
                            ))
                        } 
                </tbody>
            </table>
        </>
     );
}
 
export default WorkTable;